export const ctaAction = (
  fieldName: string,
  setEventDetails: (details: {
    eventName: string | null;
    args: string[];
  }) => void,
) => {
  const checkboxes = document.querySelectorAll(
    ".s-step-recommendations input[type=checkbox]",
  );

  checkboxes.forEach(box => {
    if ((box as HTMLInputElement).name === fieldName) {
      (box as HTMLInputElement).click();

      if ((box as HTMLInputElement).checked === true) {
        setEventDetails({
          eventName: "coverage_selection_recommendations_coverage_added",
          args: [fieldName],
        });
      } else {
        setEventDetails({
          eventName: "coverage_selection_recommendations_coverage_removed",
          args: [fieldName],
        });
      }
    }
  });
};
